module.exports = __webpack_public_path__ + "media/images/img-fairy-f7c971ea170de4834ad1401114e64d82.png";